import styled from 'styled-components';

// Uses the legacy WebKit property -webkit-line-clamp since it's well supported in browsers
// and the line-clamp property from the CSS Overflow Module Level 4 spec  is not available yet.
// See: https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-line-clamp
export const LineClamp = styled.div<{ $numLinesToClamp: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.$numLinesToClamp};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
